/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GradedAttemptTabMode } from './gradedAttemptTabMode';
import type { GradedAttemptTaskFeedback } from './gradedAttemptTaskFeedback';

/**
 * One graded exam attempt on the grade report.
 */
export interface GradedAttemptTab {
  number: number;
  mode: GradedAttemptTabMode;
  grade: number;
  countedAt: string;
  comment?: string;
  tasks?: GradedAttemptTaskFeedback[];
}
